module.exports = __webpack_public_path__ + "img/已献花.335c0f2a.png";